module.exports = __webpack_public_path__ + "static/media/chefs-banner.956ae793.jpg";